import { AfterViewInit, Component, Input, OnDestroy } from "@angular/core";
import { Subscription } from "apollo-client/util/Observable";
import { find } from "lodash";
import { ProductRequestService } from "../../graphql/product-requests.service";
import { AttachmentCategory, AttachmentLookupService } from "../lookup-values/attachment-lookup-service";

@Component({
    selector: "attachment-type-selector",
    templateUrl: "./attachment-type-selector.component.html",
    providers: [AttachmentLookupService],
    styleUrls: [],
})
export class AttachmentTypeSelectorComponent implements OnDestroy, AfterViewInit {

    @Input() attachmentId: string;
    @Input() selectedType: number;

    public attachmentTypes: AttachmentCategory[] = [];
    public subscription$: Subscription;

    constructor(private productRequestService: ProductRequestService,
                private attachmentLookupService: AttachmentLookupService) {

    }

    ngOnDestroy(): void {
        this.subscription$.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.subscription$ = this.attachmentLookupService.getAttachmentCategories().subscribe((res) => {
                this.attachmentTypes = res;
            },
        );
    }

    public setDropDownValue(value) {
        if (!value) { return; }

        this.selectedType = value;
        this.productRequestService.updateProductVersionAttachment(this.attachmentId, this.selectedType);
    }

    public getDropDownValue(): string {
        if (!this.attachmentTypes.length) { return "Loading..."; }

        const type = find(this.attachmentTypes, (t) => Number(t.id) === Number(this.selectedType));
        return type ? type.name : "";
    }
}
